<template>
  <span
      class="STATUS-BUBBLE ellipsize">
    {{ statusLabel }}
  </span>
</template>

<script>
import { SUB_STATUS_OPTIONS } from '@/constants/sub-status-options';

export default {
  SUB_STATUS_OPTIONS,
  name: 'sub-status-bubble',
  props: {
    status: String,
  },
  computed: {
    statusLabel () {
      let statusLabel;
      if (this.status) {
        const formattedStatus = this.status.toLowerCase().replaceAll(/[^a-z]+/g, '_').replace(/_+$/, '') || '';
        statusLabel = this.$options.SUB_STATUS_OPTIONS[formattedStatus];
      }
      if (statusLabel) {
        return statusLabel.sub_status_short_description;
      }
      return 'Select Status';
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  @import "~@/views/Dashboard/constants";

  .STATUS-BUBBLE {
    @include text-small;
    max-width: 100%;
    align-items: center;
    height: 3*$unit;
    padding: $unit/3 $unit;
    color: $color-gray70;
    font-weight: 400;
    background-color: $color-gray20;
    border-radius: 2*$unit;
    border: 1px solid $color-gray70;
    text-transform: uppercase;
    will-change: color, background-color;
    transition: color $transition-half-duration,
      background-color $transition-half-duration;
  }
</style>
